import { useDarkMode } from "@/hooks/useDarkMode";
import React from "react";
import { BsCheck } from "react-icons/bs";

interface CheckmarkProps {
  disabled: boolean;
  label?: string;
}

function Checkmark(props: CheckmarkProps) {
  const { disabled, label } = props;
  const isDark = useDarkMode();
  return (
    <div
      className={`rounded-full ${
        disabled
          ? "bg-transparent border-[#CBC9F2]"
          : "bg-success-200 border-primary-500"
      } w-5 h-5 flex justify-center items-center border`}
      role="img"
      aria-label={label ? `${disabled ? 'Not met' : 'Met'}: ${label}` : (disabled ? 'Not met' : 'Met')}
    >
      <BsCheck
        size={18}
        color={
          isDark
            ? disabled
              ? "#CBC9F2"
              : "#A7F3D0"
            : disabled
              ? "#CBC9F2"
              : "#352FC3"
        }
        aria-hidden="true"
      />
    </div>
  );
}

export default Checkmark;
